import { type ComponentType } from "react"
import {
  AlibabaLogo,
  AmericaLogo,
  AnthropicLogo,
  ChinaLogo,
  DeepSeekLogo,
  GenericAILogo,
  GoogleDeepMindLogo,
  OpenAILogo,
  WorldLogo,
  XAILogo,
  type IconProps,
} from "@/ui/icons"
import { type PowerLabId, type PowerRegionId } from "./powerBubbleChartData"

// Canonical flag mark for every region. Single source of truth so the chart
// tiles and the tooltip can never drift apart on which flag a region shows.
export const regionIconById: Record<PowerRegionId, ComponentType<IconProps>> = {
  america: AmericaLogo,
  china: ChinaLogo,
  world: WorldLogo,
}

// Canonical brand mark per lab. Labs absent here have no logo and fall back to
// initials or a blank slot, depending on the caller.
export const labIconById: Partial<Record<PowerLabId, ComponentType<IconProps>>> = {
  openai: OpenAILogo,
  "google-deepmind": GoogleDeepMindLogo,
  anthropic: AnthropicLogo,
  xai: XAILogo,
  alibaba: AlibabaLogo,
  deepseek: DeepSeekLogo,
  "us-national-project": AmericaLogo,
  "chinese-megaproject": ChinaLogo,
  "US-tail": AmericaLogo,
  "CH-tail": ChinaLogo,
  "RoW-tail": WorldLogo,
}

// Brand mark for frontier labs labIconById doesn't cover — the sheet's
// anonymous "US Co N"-style holders, which have no real logo to show. A
// deliberately generic abstract-AI-company mark.
export const genericFrontierLabIcon: ComponentType<IconProps> = GenericAILogo
